import tippy from 'tippy.js';

$(function () {
  tippy('[data-tippy-content], [data-tippy]', {
    theme: 'bonkers',
    arrow: 'sharp',
    delay: 0,
    interactive: true,
    placement: 'top'
  });
});

export default function tippyTap () {
  tippy('[data-tippy-content], [data-tippy]', {
    theme: 'bonkers',
    arrow: 'sharp',
    delay: 0,
    interactive: true,
    placement: 'top'
  });
}
